import { render, staticRenderFns } from "./ShipmentPublic.vue?vue&type=template&id=3a626434&"
import script from "./ShipmentPublic.vue?vue&type=script&lang=js&"
export * from "./ShipmentPublic.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentPublic.vue?vue&type=style&index=0&id=3a626434&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports